import React from 'react'
import { StudentRow } from './'
import { ListGroup } from 'reactstrap'
import sortByPropText from '../../../../../../helpers/content/manageSets/sortByPropText';
import getStudentsByClass from '../../../../../../helpers/users/manageUsers/getStudentsByClass';

export default function StudentRows ({filter, students, record, inClass, notInClass}) {
  const studentList = getStudentsByClass(students, record, notInClass)
  const filterRule = st => st.fullName.toLowerCase().indexOf(filter.toLowerCase()) > -1
  const filteredStudentList = studentList.filter(filterRule)
                                .filter(s => s.school === record.school)
  const sortedStudentList = sortByPropText(filteredStudentList, 'lastName')


  return (
    <ListGroup>
      {sortedStudentList.map(student => 
        <StudentRow 
          student={student} 
          key={`stuRow${student.id}`}
          notInClass={notInClass}
          record={record}
        />
      )}
      {/** to be implemented */}
      <div class="load-more-action"><i class="fa fa-arrow-down" aria-hidden="true"></i></div>
    </ListGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/AssignBlockComponents/StudentRows.js